<mat-card-content class="w-100-p mb-0 active-days-container">
    <div class="p-24 stats-wrapper">
        <div fxLayout="column" class="chart-wrapper">
            <div fxLayout="row" fxLayoutAlign="flex-start space-between" class="chart-title-wrapper mb-12">
                <div
                    fxLayoutAlign="center center"
                    class="icon-wrapper mr-8"
                    [ngStyle]="{
                        background: '#F0BFDF',
                        fill: '#C5639C'
                    }"
                >
                    <mat-icon svgIcon="dashboard_grow_daily_posting_link_followed"></mat-icon>
                </div>
                <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title">
                    {{ 'TENANT_DASHBOARD.CHART.active_days' | translate }}
                    <span
                        class="ml-8 info-icon"
                        fxLayoutAlign="center center"
                        matTooltip="{{ 'TENANT_DASHBOARD.CHART.TOOLTIP.active_days' | translate }}"
                        matTooltipPosition="above"
                    >
                        i
                    </span>
                </label>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between start" class="active-days" fxFlex="1 1 auto">
                <div fxLayout="column" fxLayoutAlign="center center" fxFlex="50%" class="bg-zinc-50 p-16 rounded-sm mr-8 h-full">
                    <span class="mb-12 uppercase text-center text-gray-600 text-xs tracking-widest">{{ 'TEAMS.LABEL.TOP_THREE_USERS' | translate }}</span>
                    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="team.topThree.length; else noTopThreeUsers">
                        <div *ngFor="let user of team.topThree" class="relative user-details-card-container">
                            <div #userAvatar class="pointer">
                                <img class="avatar mr-4" *ngIf="user.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                </ng-template>
                                <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                            </div>
                            <app-user-details-card [user]="user" [target]="userAvatar" [isTitleClickable]="false" openedFrom="team_admin_space"></app-user-details-card>
                        </div>
                    </div>
                    <ng-template #noTopThreeUsers>&#8212;</ng-template>
                </div>

                <div fxLayout="column" fxLayoutAlign="center center" fxFlex="50%" class="bg-zinc-50 p-16 rounded-sm h-full">
                    <span class="mb-12 uppercase text-center text-gray-600 text-xs tracking-widest">{{ 'TEAMS.LABEL.LOW_THREE_USERS' | translate }}</span>
                    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="team.lowThree.length; else noLowThreeUsers">
                        <div *ngFor="let user of team.lowThree" class="relative user-details-card-container">
                            <div #userAvatar class="pointer">
                                <img class="avatar mr-4" *ngIf="user.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                </ng-template>
                                <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                            </div>
                            <app-user-details-card [user]="user" [target]="userAvatar" [isTitleClickable]="false" openedFrom="team_admin_space"></app-user-details-card>
                        </div>
                    </div>
                    <ng-template #noLowThreeUsers>&#8212;</ng-template>
                </div>
            </div>
        </div>
    </div>
</mat-card-content>
